<div class="nw">

  <!-- HEADER -->
  <div class="nw-header">

    <div class="nw-topbar">
      <div class="nw-title">
        <div class="nw-icon"><i class="pi pi-clipboard"></i></div>
        <span>Lançar notas</span>
      </div>
      <button class="nw-close" (click)="tentarFechar()" pTooltip="Fechar" tooltipPosition="left">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="nw-selection">
      <label for="matricula">Ano lectivo</label>
      <p-select inputId="matricula" appendTo="body" [options]="matriculaOptions" optionLabel="label" optionValue="id"
        [(ngModel)]="selectedMatriculaId" (ngModelChange)="onMatriculaChange($event)"
        placeholder="Seleccione uma matrícula" [filter]="matriculaOptions.length > 6"
        [showClear]="matriculaOptions.length > 1" styleClass="w-full"></p-select>
      <small *ngIf="matriculaOptions.length > 1">As disciplinas são carregadas de acordo com a matrícula
        seleccionada.</small>
    </div>

    <div class="nw-student">
      <span class="nw-lbl">ESTUDANTE</span>
      <span class="nw-student-name">{{ bolseiroNome || '—' }}</span>
    </div>

    <div class="nw-grid2">
      <div class="nw-cell">
        <span class="nw-lbl">CURSO</span>
        <span class="nw-val" [title]="curso">{{ curso || '—' }}</span>
      </div>
      <div class="nw-cell">
        <span class="nw-lbl">INSTITUIÇÃO</span>
        <span class="nw-val" [title]="instituicao">{{ instituicao || '—' }}</span>
      </div>
    </div>

    <div class="nw-grid2 nw-badges">
      <div class="nw-cell">
        <span class="nw-lbl">ANO CURRICULAR</span>
        <span class="nw-badge purple">{{ formatAnoCurricular(anoCurricular) }}</span>
      </div>
      <div class="nw-cell">
        <span class="nw-lbl">ANO LECTIVO</span>
        <span class="nw-badge neutral">{{ anoLectivo || '—' }}</span>
      </div>
    </div>

  </div>

  <!-- BODY -->
  <div class="nw-body">

    <div *ngIf="isLoading" class="nw-skeletons">
      <div class="nw-skel-row" *ngFor="let i of [1,2,3,4,5,6]">
        <div class="sk sk-idx"></div>
        <div class="sk sk-name"></div>
        <div class="sk sk-inp"></div>
        <div class="sk sk-btn"></div>
      </div>
    </div>

    <ng-container *ngIf="!isLoading">

      <div class="nw-fallback" *ngIf="semPlanoAnoCurricular">
        <i class="pi pi-info-circle"></i>
        <span>Plano sem divisão por ano — a mostrar todas as disciplinas.</span>
      </div>

      <div class="nw-section-bar">
        <span class="nw-section-lbl">DISCIPLINAS</span>
        <span class="nw-count" [class.zero]="disciplinaRows.length === 0">{{ disciplinaRows.length }}</span>
      </div>

      <div *ngIf="disciplinaRows.length === 0" class="nw-empty">
        <div class="nw-empty-icon"><i class="pi pi-book"></i></div>
        <p class="nw-empty-title">Sem disciplinas</p>
        <p class="nw-empty-sub">
          Não foram encontradas disciplinas para o <strong>{{ formatAnoCurricular(anoCurricular) }}</strong>.
        </p>
        <p class="nw-empty-hint">
          <i class="pi pi-cog"></i>
          Verifique o plano curricular na instituição de ensino.
        </p>
      </div>

      <div *ngFor="let row of disciplinaRows; let i = index" class="nw-row" [class.is-saved]="row.saved"
        [class.is-error]="row.error">
        <span class="nw-num">{{ i + 1 }}</span>

        <div class="nw-disc">
          <span class="nw-disc-name">{{ row.nome }}</span>
          <span class="nw-disc-sub" *ngIf="row.notaActual !== null">
            <i class="pi pi-check-circle"></i> Nota actual: <strong>{{ row.notaActual }}</strong>
          </span>
        </div>

        <div class="nw-actions">
          <div class="nw-inp-wrap" [class.filled]="row.saved" [class.has-error]="row.error">
            <input type="number" min="0" max="20" step="1" class="nw-inp" [(ngModel)]="row.inputValue"
              [placeholder]="row.notaActual ?? '—'" [disabled]="true" />
          </div>
          <!-- <button
            class="nw-save"
            [class.saved]="row.saved"
            (click)="saveNota(row)"
            [disabled]="row.loading || !row.inputValue"
            [pTooltip]="row.saved ? 'Guardado' : 'Guardar'"
            tooltipPosition="left"
          >
            <i *ngIf="!row.loading && !row.saved" class="pi pi-save"></i>
            <i *ngIf="!row.loading && row.saved" class="pi pi-check"></i>
            <i *ngIf="row.loading" class="pi pi-spin pi-spinner"></i>
          </button> -->
        </div>
      </div>

    </ng-container>
  </div>

  <!-- FOOTER -->
  <div class="nw-footer" *ngIf="!isLoading">
    <div class="nw-progress">
      <div class="nw-track">
        <div class="nw-fill" [style.width.%]="disciplinaRows.length ? (savedCount / disciplinaRows.length) * 100 : 0">
        </div>
      </div>
      <span class="nw-prog-lbl"><strong>{{ savedCount }}</strong> de {{ disciplinaRows.length }} lançadas</span>
    </div>
    <div class="nw-btns">
      <button class="nw-btn-cancel" (click)="tentarFechar()">Fechar</button>
      <!-- Código de lançamento/atualização de notas comentado
      <button class="nw-btn-save" (click)="saveAll()" [disabled]="disciplinaRows.length === 0">
        <i class="pi pi-save"></i> Guardar tudo
      </button>
      -->
    </div>
  </div>

</div>

<p-toast position="top-right"></p-toast>
<p-confirmdialog></p-confirmdialog>